import { BaseAddress } from '~/types/Address';
import APIAddress from '~/types/APIAddress';
import { ActionKeys } from './constants';
import { TrackingReference } from '~/utils/TrackingHelper/types';

export interface ManualOrderAddresses {
  sender?: APIAddress; // type here
  return?: APIAddress; // type here
  recipient?: BaseAddress; // @TODO type
}

export interface ManualOrderConditionals {
  saveAsDefaultSenderAddress: boolean;
  useSenderAddressAsReturn: boolean;
  saveAsDefaultReturnAddress: boolean;
}

export interface ManualOrder {
  conditionals: ManualOrderConditionals;
  addresses: ManualOrderAddresses;
}

export function createOrder(manualOrder: ManualOrder, trackingReference: TrackingReference) {
  return <const>{
    type: ActionKeys.MANUALORDER_SAVE_ORDER,
    payload: {
      manualOrder,
      trackingReference,
    },
  };
}

export function createOrderSuccess(objectId: string) {
  return <const>{
    type: ActionKeys.MANUALORDER_SAVE_ORDER_SUCCESS,
    payload: {
      objectId,
    },
  };
}

export function createOrderError(message: string, error: Error) {
  return <const>{
    type: ActionKeys.MANUALORDER_SAVE_ORDER_FAILURE,
    payload: {
      message,
      error,
    },
  };
}

export function clearError() {
  return <const>{
    type: ActionKeys.MANUALORDER_CLEAR_ERROR_MESSAGE,
  };
}

export function manualOrderReset() {
  return <const>{
    type: ActionKeys.MANUALORDER_RESET,
  };
}

export type ManualOrderActions =
  | ReturnType<typeof createOrder>
  | ReturnType<typeof createOrderSuccess>
  | ReturnType<typeof createOrderError>
  | ReturnType<typeof clearError>
  | ReturnType<typeof manualOrderReset>;
